// ── XP Toast ───────────────────────────────────────────────────────────────────
// RWD-7/RWD-8: renamed from CPToast. The backend scores questions 1–3 XP
// (pre-RWD-8 this was 1–3 CP — the 0-3 scale didn't change, only the
// currency label did). "+1 XP" / "+2 XP" / "+3 XP" now match the chat
// response field (`xpEarned`) and the voter-level XP badge in the nav.
export function XpToast({xp, onDone}) {
  const color = xp===3?"#f59e0b":xp===2?"#3b82f6":"#475569";
  const label = xp===3?"🔥 Deep question":xp===2?"✨ Good question":"💬 Question asked";
  return (
    <div style={{position:"fixed",bottom:90,left:"50%",transform:"translateX(-50%)",zIndex:999,animation:"slideUp .3s ease",pointerEvents:"none"}}
      onAnimationEnd={()=>setTimeout(onDone,1800)}>
      <div style={{background:"#0d1724",border:`1px solid ${color}40`,borderRadius:20,padding:"8px 16px",display:"flex",alignItems:"center",gap:8,boxShadow:"0 4px 20px #00000066",whiteSpace:"nowrap"}}>
        <span style={{color,fontWeight:800,fontSize:15}}>+{xp} XP</span>
        <span style={{color:"#64748b",fontSize:12}}>{label}</span>
      </div>
    </div>
  );
}

// ── Trivia Play Unlocked Modal ────────────────────────────────────────────────
// RWD-7/RWD-8: was "Token Earned" — renamed to match the new vocabulary.
// Trivia plays are no longer a per-persona "token" in a pool; they're a
// per-voter count derived from total XP earned (every 10 XP = 1 play).
export function TriviaPlayUnlockedModal({persona, xpPerPlay = 10, onPlayNow, onLater}) {
  const pc = persona.accentColor;
  return (
    <div style={{position:"fixed",inset:0,background:"#000000cc",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#0d1724",border:`1px solid ${pc}40`,borderRadius:20,padding:"32px 24px",maxWidth:360,width:"100%",textAlign:"center",animation:"popIn .4s ease",boxShadow:`0 0 60px ${pc}22`}}>
        <div style={{position:"relative",display:"inline-block",marginBottom:16}}>
          <div style={{width:80,height:80,borderRadius:"50%",background:`conic-gradient(${pc},#8b5cf6,${pc})`,padding:3,animation:"spin 3s linear infinite"}}>
            <div style={{width:"100%",height:"100%",borderRadius:"50%",background:"#0d1724",display:"flex",alignItems:"center",justifyContent:"center",fontSize:32}}>🎫</div>
          </div>
        </div>
        <h2 style={{color:"#f1f5f9",fontSize:20,fontWeight:900,fontFamily:"Georgia,serif",margin:"0 0 8px"}}>Trivia Play Unlocked!</h2>
        <p style={{color:"#64748b",fontSize:13,lineHeight:1.7,margin:"0 0 6px"}}>
          You've earned <strong style={{color:pc}}>{xpPerPlay} XP</strong> — enough for a trivia round with
        </p>
        <p style={{color:"#f1f5f9",fontWeight:700,fontSize:14,margin:"0 0 22px"}}>{persona.name}</p>
        <div style={{background:`${pc}12`,border:`1px solid ${pc}30`,borderRadius:11,padding:"12px 16px",marginBottom:22,fontSize:12,color:"#94a3b8",lineHeight:1.6}}>
          🎯 Test your knowledge in a <strong style={{color:"#f1f5f9"}}>5-question trivia round</strong>.<br/>
          Earn up to <strong style={{color:"#f59e0b"}}>5 XP</strong> to spend in the Reward Shop.
        </div>
        <div style={{display:"flex",gap:9}}>
          <button onClick={onLater} style={{flex:1,padding:"11px",background:"#090e1a",border:"1px solid #1e2d45",borderRadius:10,color:"#64748b",fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>Save for Later</button>
          <button onClick={onPlayNow} style={{flex:2,padding:"11px",background:`linear-gradient(135deg,${pc},${pc}bb)`,color:"#fff",border:"none",borderRadius:10,fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>🎯 Play Now</button>
        </div>
      </div>
    </div>
  );
}
